var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('CButton',{staticClass:"mb-2",attrs:{"color":"success"},on:{"click":_vm.hello}},[_vm._v(_vm._s(_vm.printVal()))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }